import EmailCard from './EmailCard'

export default EmailCard
